import { Settings } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const ConfigurationIcon = createNavigationLucideIcon(Settings);
